import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui';
import { actions as operationActions } from 'ducks/uiOperations';
import { actions as formActions } from 'ducks/form';
import { selectors as invoiceSelector, actions as invoiceActions } from 'ducks/customerEnquiry/invoices';
import { selectors as customerSelector } from 'ducks/customer';
import { fetch } from 'api/customerEnquiry/invoices';
import { actions as filterActions, selectors as filterSelectors } from 'ducks/common/filters';

const params = new URLSearchParams(location.search)

export const mapStateToProps = state => ({
  gridName: 'Invoices',
  columnDefs: invoiceSelector.columns(state),
  rowData: invoiceSelector.Data(state),
  isCustomerLookUpOpen: uiSelectors.isCustomerLookUpOpen(state),
  gridOptions: invoiceSelector.gridOptions(state),
  filterRow: invoiceSelector.filterRow(state),
  selectedFilters: invoiceSelector.selectedFilters(state),
  isLoading: invoiceSelector.isLoading(state),
  appliedFilters: invoiceSelector.filterRow(state) && filterSelectors.getFilters(state, invoiceSelector.filterRow(state).formName),
  reqParams: (customerSelector.selected(state) || params.get('CustomerId'))
    &&
    {
      CustomerId: (customerSelector.selected(state) && customerSelector.selected(state).CustomerId) || params.get('CustomerId')
    },
  apiMethod: fetch
});

export const actions = {
  deleteSelectedRecords: invoiceActions.remove,
  changeSelectedTab: uiActions.changeSelectedTab,
  changeOperationMode: operationActions.changeOperationMode,
  getFormSchema: formActions.search,
  changeSelectedForm: formActions.setSelected,
  setSelectedOrderLine: invoiceActions.setSelected,
  applyFilters: filterActions.applyFilters
}
